<template>
    <div class="modal-container">
        <div class="animate  send-friendship">
            <div class="close" @click="close"><v-icon name="ri-close-circle-fill" fill="lightcoral" scale="1.5" /></div>
            <img :src="main.LOGO_URI" width="256">
            <div class="spacer"></div>
            <h3>Añadir amigo/a</h3>
            <div class="spacer"></div>
            <p>Podrás mensajearte con los amigos que añadas.Introduce su email y le llegará una petición de amistad. Si
                el usuario no está registrado en la plataforma, se le enviará un email de invitación.</p>
            <div class="spacer"></div>
            <div class="input-box">
                <input type="email" placeholder="Introduce email" v-model="email" />
                <button @click="sendInvitation">Enviar petición</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import main from '@/data/main.js'
import { defineEmits, ref } from 'vue'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import FriendshipService from '@/services/FriendshipService'
import { useAuth } from '@/store/useAuth'

const emit = defineEmits(['close'])
const email = ref('')
const toast = useToast()
const friendshipService = new FriendshipService()
const store = useAuth()

const sendInvitation = async () => {
    if(!store.token) {
        return
    }
    if(email.value.length < 5) {
        toast.showToast("Email no válido", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await friendshipService.sendFriendshipRequest(store.token, email.value)
    toast.showToast(response.message, Toast.INFO)
    setTimeout(function () { toast.hideToast() }, 4000);
    email.value = ""
    emit('close')
}

const close = () => {
    email.value = ""
    emit('close')
}
</script>

<style lang="scss" scoped>
.close {
    top: -10px;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    font-size: 12px;
}
.input-box {
    display: flex;
    width: 100%;

    button {
        width: 20%;
        border: 1px solid #ccc;
        border-bottom-right-radius: 10px;
        border-top-right-radius: 10px;
        cursor: pointer;
    }
    button:hover {
        background-color: $secondary-color;
        color: white;
        border: 1px solid $secondary-color;
    }
}
input {
    border: 1px solid #ccc;
    border-radius: 10px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    padding: 10px;
    width: 80%;
}

.modal-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $secondary-color;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999999999999999999999999;
}

.send-friendship {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px;
    border-radius: 10px;
    border: 1px solid $primary-color;
    margin-bottom: 20px;
    background-color: white;
    display: flex;
    flex-direction: column;
    max-width: 600px;
}


</style>